if (!customElements.get('fixed-image-cards-slider')) {
  class FixedImageCardsSlider extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.splide = null;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.init();
    }

    init() {
      if (typeof window.Splide !== 'undefined') {
        this.mountSlider();
        return;
      }

      const checkInterval = window.setInterval(() => {
        if (typeof window.Splide !== 'undefined') {
          window.clearInterval(checkInterval);
          this.mountSlider();
        }
      }, 100);

      window.setTimeout(() => {
        window.clearInterval(checkInterval);
      }, 10000);
    }

    mountSlider() {
      const slider = this.querySelector('[data-fixed-image-cards-slider]');
      if (!slider || slider.dataset.sliderMounted === 'true') return;

      const totalSlides = slider.querySelectorAll('.splide__slide').length;
      if (!totalSlides) return;

      const stretchTwoSlides = slider.dataset.stretchTwoSlides === 'true' && totalSlides === 2;
      const showControls = totalSlides > 1;

      slider.dataset.sliderMounted = 'true';

      const splide = new Splide(slider, {
        type: 'slide',
        arrows: showControls,
        pagination: showControls,
        drag: showControls,
        rewind: false,
        speed: 500,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        gap: '24px',
        perMove: 2,
        perPage: 2,
        flickMaxPages: 1,
        updateOnMove: true,
        fixedWidth: stretchTwoSlides ? false : '520px',
        fixedHeight: '292px',
        padding: {
          left: '0px',
          right: showControls && !stretchTwoSlides ? '120px' : '0px',
        },
        classes: {
          arrows: 'splide__arrows fixed-image-cards-slider__arrows',
          arrow: 'splide__arrow fixed-image-cards-slider__arrow',
          prev: 'splide__arrow--prev fixed-image-cards-slider__arrow fixed-image-cards-slider__arrow--prev',
          next: 'splide__arrow--next fixed-image-cards-slider__arrow fixed-image-cards-slider__arrow--next',
          pagination: 'splide__pagination fixed-image-cards-slider__pagination',
          page: 'splide__pagination__page fixed-image-cards-slider__pagination-dot',
        },
        breakpoints: {
          1023: {
            perMove: 1,
            perPage: 1,
          },
          767: {
            gap: '16px',
            perMove: 1,
            perPage: 1,
            fixedWidth: false,
            fixedHeight: false,
            padding: {
              left: '0px',
              right: showControls ? '6%' : '0px',
            },
          },
        },
      });

      if (showControls) {
        let paginationItems = [];
        const getPageSize = () => (window.matchMedia('(min-width: 1024px)').matches ? 2 : 1);
        const updateActivePagination = () => {
          if (!paginationItems.length) return;

          const activePage = Math.min(
            Math.floor(splide.index / getPageSize()),
            paginationItems.length - 1
          );

          paginationItems.forEach((item, index) => {
            const isActive = index === activePage;

            item.button.classList.toggle('is-active', isActive);
            item.button.setAttribute('aria-selected', isActive ? 'true' : 'false');
            item.button.setAttribute('tabindex', isActive ? '0' : '-1');
          });
        };

        splide.on('arrows:mounted', (prev, next) => {
          const arrowIcon = `
            <span class="fixed-image-cards-slider__arrow-icon" aria-hidden="true">
              <svg viewBox="0 0 27 17" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.667 9.81849L26.6672 7.15196H5.10467L10.3709 1.88561L8.48534 0L0 8.48529L8.48534 16.9706L10.3709 15.0849L5.10453 9.81863L26.667 9.81849Z" />
              </svg>
            </span>
          `;

          if (prev) {
            prev.innerHTML = arrowIcon;
            prev.setAttribute('aria-label', 'Previous slide');
          }

          if (next) {
            next.innerHTML = arrowIcon;
            next.setAttribute('aria-label', 'Next slide');
          }
        });

        splide.on('pagination:mounted', (data) => {
          paginationItems = data.items;

          data.items.forEach((item, index) => {
            item.button.innerHTML = `
              <span class="fixed-image-cards-slider__pagination-icon" aria-hidden="true">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5 0L15.5 7.5L23 11.5L15.5 15.5L11.5 23L7.5 15.5L0 11.5L7.5 7.5L11.5 0Z" fill="white"/>
                </svg>
              </span>
            `;
            item.button.setAttribute('aria-label', `Go to slide ${index + 1}`);

            item.button.addEventListener(
              'click',
              (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                splide.go(index * getPageSize());
                window.requestAnimationFrame(updateActivePagination);
              },
              true
            );
          });

          updateActivePagination();
        });

        splide.on('move moved active pagination:updated resized updated', () => {
          window.requestAnimationFrame(updateActivePagination);
        });
      }

      splide.mount();
      this.splide = splide;
    }
  }

  customElements.define('fixed-image-cards-slider', FixedImageCardsSlider);
}
